/**
 * Scroll behavior that respects the advisor's "reduce motion" setting (WCAG 2.3.3). CSS
 * `scroll-behavior` doesn't apply when a script asks for `behavior: 'smooth'`, so scroll calls
 * use this instead.
 */
export function scrollBehavior(): ScrollBehavior {
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}
